import React from 'react';
import CardHeader from "@mui/material/CardHeader";
import IconButton from "@mui/material/IconButton";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import PropTypes from 'prop-types';

const SettingHeader = ({ backClickCallback }) => {
    return (
        <CardHeader
            avatar={
                <IconButton sx={{ ml: -1.5 }} aria-label="back" onClick={backClickCallback}>
                    <ArrowBackIosNewIcon fontSize={"small"} />
                </IconButton>
            }
            title={"Setting"}
            subheader={"Select your preferences"}
        />
    );
};

SettingHeader.propTypes = {
    backClickCallback: PropTypes.func.isRequired,
};

export default SettingHeader;